import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Input, Label, FormGroup } from 'reactstrap';
import moment from 'moment';

import Table, { ExpandableRow } from '../../components/ExpandableTable';

import actions from './actions';

class Lista extends Component {
  constructor (props) {
    super(props);

    this.state = {
      data: {
        nome: '',
        data_nascimento: '',
        pne: '-1'
      }
    };

    this.addItem = this.addItem.bind(this);
  }

  componentDidMount () {
    this.props.actions.onLoadListaMoradores();
  }

  onChange (field) {
    return (e) => {
      let value = e.target.value.toUpperCase().replace(/^\s+|\s+(?=\s$|\s)/g, "");
      if ("checkbox" === field.type) {
        value = e.target.checked?field.TRUE:field.FALSE;
      }

      this.setState(state => ({
        ...state,
        data: {
          ...state.data,
          [field.name]: value
        }
      }));
    }
  }

  dateFormat (value) {
    return !!value && moment(value).format("DD/MM/YYYY");
  }

  pneFormat (value) {
    return ["Não", "-", "Sim"][1 + value];
  }

  removeItem (item) {
    return (e) => {
      e.preventDefault();
      e.stopPropagation();

      this.props.actions.desabilitaMorador(item);
    };
  }

  resetValues () {
    this.setState({
      data: {
        nome: '',
        data_nascimento: '',
        pne: '-1'
      }
    });
  }

  addItem () {
    this.props.actions.adicionaMorador(this.state.data)
    .then(() => this.resetValues())
    .then(() => this.props.actions.onLoadListaMoradoresIfNeeded());
  }

  isValid () {
    const { nome, data_nascimento } = this.state.data;

    return 5 < nome.length && !!data_nascimento && moment().isSameOrAfter(data_nascimento, 'day');
  }

  render() {
    const { data } = this.state;
    const { value: { result, fetching } } = this.props;

    return (
      <Table hover responsive size="sm">
        <thead>
          <tr>
            <th colSpan="4">Moradores</th>
          </tr>
          <tr>
            <th>Nome</th>
            <th>Nascimento</th>
            <th>PNE</th>
            <th className="text-right">Ação</th>
          </tr>
        </thead>
        {result.map((v, i) => (
          <ExpandableRow key={i}>
            <td>{v.nome}</td>
            <td>{moment(v.data_nascimento).format('DD/MM/YYYY')} ({moment().diff(v.data_nascimento, 'years')})</td>
            <td>{this.pneFormat(v.pne)}</td>
            <td className="text-right"><Button color="danger" size="sm" onClick={this.removeItem(v)}><span className="fa fa-minus"></span> <span className="d-none d-md-inline-block">Remover</span></Button></td>
          </ExpandableRow>
        ))}
        <tfoot>
          <tr>
            {[
              {name:'nome', type:'text', inputProps:{ required: true, maxLength:100, valid: 5 < data.nome.length }},
              {name:'data_nascimento', type:'date', inputProps:{ required: true, max: moment().format('YYYY-MM-DD'), valid: !!data.data_nascimento && moment().isSameOrAfter(data.data_nascimento, 'day') }},
              {name:'pne',type:'checkbox','TRUE':'1','FALSE':'-1', labelProps:{ check: true }}
            ].map(v => (
              <th key={v.name}><FormGroup {...v.labelProps}><Label hidden {...v.labelProps}>{v.name}</Label><Input bsSize="sm" type={v.type} disabled={1 === fetching} value={data[v.name]} onChange={this.onChange(v)} {...v.inputProps} /></FormGroup></th>
            ))}
            <th className="text-right"><Button disabled={1 === fetching || !this.isValid()} color="success" size="sm" onClick={this.addItem}><span className="fa fa-plus"></span> <span className="d-none d-md-inline-block">Adicionar</span></Button></th>
          </tr>
        </tfoot>
      </Table>
    );
  }
}

let mapStateToProps = ({ unidade : { moradores } }) => ({
  value: moradores
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Lista);



// WEBPACK FOOTER //
// ./src/modules/unidade/ListaMoradores.js